/**
 * Landlord / superagent shell.
 *
 * Nav destinations mirror the landlord tab table in app_router.dart:122-130 and
 * the child routes at app_router.dart:155-215. Every target beyond the
 * dashboard is a feature-phase page and is not routed yet — the links are here
 * so the shell's shape is reviewable now.
 */
import {
  Dashboard,
  Building,
  UserMultiple,
  Money,
  ToolBox,
  Receipt,
  Logout,
  Chat,
  Send,
  ChartBar,
  Security,
  User,
  WarningAlt,
} from '@carbon/icons-react';
import { ShellFrame, type NavItem } from './ShellFrame';

const NAV_ITEMS: readonly NavItem[] = [
  { label: 'Dashboard', to: '/landlord', end: true, icon: Dashboard },
  { label: 'Properties', to: '/landlord/properties', icon: Building },
  { label: 'Tenants', to: '/landlord/tenants', icon: UserMultiple },
  { label: 'Rent', to: '/landlord/rent', icon: Money },
  { label: 'Maintenance', to: '/landlord/maintenance', icon: ToolBox },
  { label: 'Expenses', to: '/landlord/expenses', icon: Receipt },
  { label: 'Offboarding', to: '/landlord/offboarding', icon: Logout },
  { label: 'Messages', to: '/landlord/messages', icon: Chat },
  { label: 'Eviction notices', to: '/landlord/eviction-notices', icon: WarningAlt },
  { label: 'Broadcasts', to: '/landlord/broadcasts', icon: Send },
  { label: 'Reports', to: '/landlord/reports', icon: ChartBar },
  // Superagent-only in the Flutter app (UserManagementScreen,
  // app_router.dart:207-210). Filtering this item by role belongs with the page.
  { label: 'Users', to: '/landlord/users', icon: Security },
  { label: 'Profile', to: '/landlord/profile', icon: User },
];

export function LandlordShell(): React.JSX.Element {
  return <ShellFrame title="Landlord" navItems={NAV_ITEMS} />;
}

export default LandlordShell;
